module.exports = __webpack_public_path__ + "img/keep-docs-secure.94c85e6b.png";